import { Box, Typography, Chip, Tooltip } from "@mui/material";
import { AppCategory } from "../types/appIntegration.types";
import { APP_CATEGORIES } from "../constants/appCategories.config";
import { colors } from "../../ui/colors";
import { baseColor, baseContrastColor, contrastColor, contrastColorHoover } from "../../virtual-receptionist/VirtualReceptionistView";

interface Props {
  categories: AppCategory[];
  selectedCategory: AppCategory | null;
  onSelect: (category: AppCategory | null) => void;
}

export const AppCategoryFilter = ({ categories, selectedCategory, onSelect }: Props) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="body2"
        sx={{
          fontSize: "0.875rem",
          fontWeight: 600,
          color: "var(--fx-surface-textsecondary, #64748B)",
          mb: 2,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        Filter by Category
      </Typography>

      <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
        <Chip
          label="All"
          onClick={() => onSelect(null)}
          variant={selectedCategory === null ? "filled" : "outlined"}
          sx={{
            backgroundColor: selectedCategory === null ? colors.orange.base : "transparent",
            color: selectedCategory === null ? "#fff" : "inherit",
            borderColor: selectedCategory === null ? colors.orange.base : "#d1d5db",
            cursor: "pointer",
            transition: "all 0.2s ease",

            "&:hover": {
              backgroundColor: selectedCategory === null ? colors.orange.base : `${colors.orange.base}15`,
              borderColor: colors.orange.base,
              color: selectedCategory === null ? "#fff" : colors.orange.base,
            },
          }}
        />

        {categories.map((category) => {
          const info = APP_CATEGORIES[category];
          const isSelected = selectedCategory === category;

          return (
            <Tooltip key={category} title={info.description} arrow placement="top" enterDelay={300}>
              <Chip
                label={info.name}
                onClick={() => onSelect(category)}
                color={isSelected ? "primary" : "default"}
                variant={isSelected ? "filled" : "outlined"}
                sx={{
                  backgroundColor: isSelected ? baseColor : "transparent", // estoy ambiando info color a base color
                  color: isSelected ? "#fff" : "inherit",
                  "&:hover": {
                    backgroundColor: isSelected ? baseColor : `${info.color}15`, // estoy cambiando info.color a baseColor
                    borderColor: info.color,
                    color: isSelected ? "#fff" : info.color,
                  },
                }}
              />
            </Tooltip>
          );
        })}
      </Box>
    </Box>
  );
};
